var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkdnicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1710_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4273 33.8041L33.4356 33.8028V21.5401C33.4356 15.5411 32.1442 10.9199 25.131 10.9199C21.7595 10.9199 19.497 12.7701 18.5733 14.5241H18.4758V11.48H11.8262V33.8028H18.7502V22.7493C18.7502 19.839 19.3019 17.0248 22.9061 17.0248C26.4572 17.0248 26.5102 20.3461 26.5102 22.936V33.8041H33.4273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.552734 11.4814H7.48515V33.8042H0.552734V11.4814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01512 0.368164C1.79858 0.368164 0 2.16675 0 4.38328C0 6.59982 1.79858 8.43602 4.01512 8.43602C6.23165 8.43602 8.03024 6.59982 8.03024 4.38328C8.02884 2.16675 6.23026 0.368164 4.01512 0.368164Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1710_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4361,
    height: 33.4361,
    fill: "white",
    transform: "translate(0 0.368164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkdnicon);
export default __webpack_public_path__ + "static/media/lkdnicon.455fb0358424f949fdb5b3f390536a48.svg";
export { ForwardRef as ReactComponent };